'use client';

import ErrorPage from '@eliadmin/core/src/pages/error';

export default function GlobalError({ error, reset }: any) {
  return (
    <html>
      <body>
        <ErrorPage error={error} reset={reset} />
      </body>
    </html>
  );
}
